import React from "react";
import { Button, Col, Row, InputGroup, Form } from "react-bootstrap";
import { ActionHandlerFunction, CollectionServerUser } from "@preveil-api";
import { AdminUIActionTypes, useAppSelector } from "src/common";
import { Icon } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  is_loading: boolean;
  filter_param: string;
  user_list: CollectionServerUser[];
  filtered_list: CollectionServerUser[];
  org_users: CollectionServerUser[];
  handleAction: ActionHandlerFunction;
}

function ToolbarComponent(props: AllProps) {
  const { filter_param, user_list, is_loading, filtered_list, org_users, handleAction } = props;
  const selected = useAppSelector((state: RootState) => state.admin.selected);
  const add_exception_user_tooltip = org_users.length === user_list.length ? "All users in your organization have been added to the exception list." : "Add Exception User";

  return <Row className="toolbar admin">
    <Col xs="auto" className="ps-2 ms-1 col-sm-4">
      <InputGroup size="sm">
        <InputGroup.Text>
          <Icon className="ficon-filter" />
        </InputGroup.Text>
        <Form.Control
          id="filter_tb"
          disabled={user_list.length === 0}
          value={filter_param}
          onChange={(e) =>
            handleAction({
              actionType: AdminUIActionTypes.SearchParam,
              params: e.target.value,
            })
          }
          type="text"
          placeholder="Filter..."
          aria-label="Filter"
        />
        {
          !!filter_param && filter_param.length > 0 &&
          <Button
            variant="icon"
            size="sm"
            className="input-group-btn"
            onClick={() => {
              handleAction({ actionType: AdminUIActionTypes.SearchParam });
            }} >
            <Icon className="ficon-x-circle" />
          </Button>
        }
      </InputGroup>
    </Col>
    <Col className="order-1">
      <span data-tooltip-id="pv-tooltip" data-tooltip-content={add_exception_user_tooltip}>
        <Button
          className="ms-1 action-toolbar-buttons"
          variant="icon"
          size="sm"
          onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}
          title="Add Exception User"
          disabled={org_users.length === user_list.length}>
          <Icon className="ficon-plus" />
        </Button>
      </span>
      <Button
        className="action-toolbar-buttons"
        variant="icon"
        size="sm"
        onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete })}
        disabled={selected.length === 0}
        title="Delete Selected"
        data-tooltip-id="pv-tooltip"
        data-tooltip-content="Delete Selected"
      >
        <Icon className="ficon-trash-2" />
      </Button>
    </Col>
    <Col xs="auto" className="order-sm-3 order-4 me-2 pagination_info">
      {user_list.length > 0 && `${filtered_list.length !== user_list.length ? `${filtered_list.length} of ` : ""} ${user_list.length} ${user_list.length > 1 ? "Users" : "User"}`}
    </Col>
    <Col className="divider order-sm-3 order-1"></Col>
    <Col xs="auto" className="p-0 order-sm-3 order-4 ms-1 refresh" >
      <Button variant="icon" size="sm"
        onClick={() => handleAction({ actionType: AdminUIActionTypes.GetRefreshRequest })}
        title="Refresh Users">
        {
          is_loading ?
            <i className="spinner"></i> :
            <Icon className="ficon-rotate-cw" />
        }
      </Button>
    </Col>
  </Row>;
}

export default React.memo(ToolbarComponent);
